/* eslint-disable */
export default {
  _1_Welcome_and_Level_Screen_Bkgd_1: '1_Welcome and Level Screen/Bkgd_1',
  _1_Welcome_and_Level_Screen_Wave_Bkgd: '1_Welcome and Level Screen/Wave_Bkgd',
  _1_Welcome_and_Level_Screen_Sub_BodyBkgd: '1_Welcome and Level Screen/Sub_BodyBkgd',
  _1_Welcome_and_Level_Screen_Wave_Midgd: '1_Welcome and Level Screen/Wave_Midgd',
  _1_Welcome_and_Level_Screen_Title_Submarine: '1_Welcome and Level Screen/Title_Submarine',
  _3_Level_Assets_Common_LightRay: '3_Level Assets_Common/LightRay',
  _1_Welcome_and_Level_Screen_WordBbl_LvlScrn: '1_Welcome and Level Screen/WordBbl_LvlScrn',
  _Hook: 'Hook',
  _Jelly03_BG: 'Jelly03_BG',
  _bgFish: 'bgFish',
  _ProgBar_LgCoin: 'ProgBar_LgCoin',
  _ProgBar_SingleCoin: 'ProgBar_SingleCoin',
  _3_Level_Assets_Common_DustMote: '3_Level Assets_Common/DustMote',
  _ProgBar_2Coins: 'ProgBar_2Coins',
  _1_Welcome_and_Level_Screen_Wave_Frgd1: '1_Welcome and Level Screen/Wave_Frgd1',
  _8_Octopus_Tentacles_Tentacle02: '8_Octopus Tentacles/Tentacle02',
  _ProgBar_CoinStk2: 'ProgBar_CoinStk2',
  _ProgBar_CoinStk1: 'ProgBar_CoinStk1',
  _4_Level_1_Lvl1_Bkgd: '4_Level 1/Lvl1_Bkgd',
  _InstructionPopUp: 'InstructionPopUp',
  _ConfirmPopUp: 'ConfirmPopUp',
  _8_Octopus_Tentacles_Tentacle_Glow02: '8_Octopus Tentacles/Tentacle_Glow02',
  _pSub: 'pSub',
  _8_Octopus_Tentacles_Tentacle06: '8_Octopus Tentacles/Tentacle06',
  _Variants_First_Grade: 'Variants/First Grade',
  _8_Octopus_Tentacles_Tentacle03: '8_Octopus Tentacles/Tentacle03',
  _1_Welcome_and_Level_Screen_Cloud1: '1_Welcome and Level Screen/Cloud1',
  _8_Octopus_Tentacles_Tentacle04: '8_Octopus Tentacles/Tentacle04',
  _1_Welcome_and_Level_Screen_Wave_Frgd2: '1_Welcome and Level Screen/Wave_Frgd2',
  _1_Welcome_and_Level_Screen_Spelly_Beak: '1_Welcome and Level Screen/Spelly_Beak',
  _Lvl4_Fish: 'Lvl4_Fish',
  _Lvl2_Fish: 'Lvl2_Fish',
  _3_Level_Assets_Common_Bbl: '3_Level Assets_Common/Bbl',
  _ProgBar: 'ProgBar',
  _1_Welcome_and_Level_Screen_SoundSign_Tentacle: '1_Welcome and Level Screen/SoundSign_Tentacle',
  _engine: 'engine',
  _Jelly04_BG: 'Jelly04_BG',
  _Jelly05_BG: 'Jelly05_BG',
  _Jelly02_BG: 'Jelly02_BG',
  _Jelly01_BG: 'Jelly01_BG',
  _7_Level_4_Lvl4_TinyOcto: '7_Level 4/Lvl4_TinyOcto',
  _1_Welcome_and_Level_Screen_Title_WithSpelly: '1_Welcome and Level Screen/Title_WithSpelly',
  _Variants_Second_Grade: 'Variants/Second Grade',
  _7_Level_4_Lvl4_TreasureGlow: '7_Level 4/Lvl4_TreasureGlow',
  _7_Level_4_Lvl4_TreasureGrtJob: '7_Level 4/Lvl4_TreasureGrtJob',
  _BblPop_03: 'BblPop_03',
  _1_Welcome_and_Level_Screen_LvlBtn6: '1_Welcome and Level Screen/LvlBtn6',
  _Variants_Third_Grade: 'Variants/Third Grade',
  _3_Level_Assets_Common_Sub_Sm_HintBtn: '3_Level Assets_Common/Sub_Sm_HintBtn',
  _Variants_Pre_Primer: 'Variants/Pre-Primer',
  _1_Welcome_and_Level_Screen_OctoWave: '1_Welcome and Level Screen/OctoWave',
  _Variants_Primer: 'Variants/Primer',
  _Jelly03_FG: 'Jelly03_FG',
  _7_Level_4_Lvl4_TreasurePile: '7_Level 4/Lvl4_TreasurePile',
  _1_Welcome_and_Level_Screen_Cloud2: '1_Welcome and Level Screen/Cloud2',
  _Variants_Nouns: 'Variants/Nouns',
  _5_Level_2_Lvl2_Bkgd: '5_Level 2/Lvl2_Bkgd',
  _6_Level_3_Lvl3_Bkgd: '6_Level 3/Lvl3_Bkgd',
  _8_Octopus_Tentacles_Tentacle_Glow03: '8_Octopus Tentacles/Tentacle_Glow03',
  _chestTentacles: 'chestTentacles',
  _3_Level_Assets_Common_Sub_Sm_Lt: '3_Level Assets_Common/Sub_Sm_Lt',
  _smallSub: 'smallSub',
  _5_Level_2_Lvl2_KelpB_4: '5_Level 2/Lvl2_KelpB_4',
  _Jelly02_MG: 'Jelly02_MG',
  _ConfirmPopUp_Cancel: 'ConfirmPopUp_Cancel',
  _ConfirmPopUp_Yes: 'ConfirmPopUp_Yes',
  _1_Welcome_and_Level_Screen_Sub_Hatch: '1_Welcome and Level Screen/Sub_Hatch',
  _1_Welcome_and_Level_Screen_Spelly_WingWave: '1_Welcome and Level Screen/Spelly_WingWave',
  _1_Welcome_and_Level_Screen_SoundsSign_Wave: '1_Welcome and Level Screen/SoundsSign_Wave',
  _1_Welcome_and_Level_Screen_Spelly_WingCtrlBkgd: '1_Welcome and Level Screen/Spelly_WingCtrlBkgd',
  _1_Welcome_and_Level_Screen_Spelly_WingCtrlFrgd: '1_Welcome and Level Screen/Spelly_WingCtrlFrgd',
  _Jelly04_FG: 'Jelly04_FG',
  _Jelly05_FG: 'Jelly05_FG',
  _1_Welcome_and_Level_Screen_Title_SpellingPractice: '1_Welcome and Level Screen/Title_SpellingPractice',
  _Jelly03_MG: 'Jelly03_MG',
  _Jelly04_MG: 'Jelly04_MG',
  _Instruction_Arrow: 'Instruction_Arrow',
  _ProgBar_Chest: 'ProgBar_Chest',
  _5_Level_2_Lvl2_KelpB_3: '5_Level 2/Lvl2_KelpB_3',
  _3_Level_Assets_Common_Sub_Sm_WindowFrgd: '3_Level Assets_Common/Sub_Sm_WindowFrgd',
  _Instructions_CloseButton: 'Instructions_CloseButton',
  _1_Welcome_and_Level_Screen_SoundSign1: '1_Welcome and Level Screen/SoundSign1',
  _1_Welcome_and_Level_Screen_SoundSign2: '1_Welcome and Level Screen/SoundSign2',
  _1_Welcome_and_Level_Screen_periscope: '1_Welcome and Level Screen/periscope',
  _8_Octopus_Tentacles_Tentacle_Glow06: '8_Octopus Tentacles/Tentacle_Glow06',
  _8_Octopus_Tentacles_Tentacle_Glow05: '8_Octopus Tentacles/Tentacle_Glow05',
  _5_Level_2_Lvl2_KelpA_2: '5_Level 2/Lvl2_KelpA_2',
  _5_Level_2_Lvl2_KelpA_3: '5_Level 2/Lvl2_KelpA_3',
  _8_Octopus_Tentacles_Tentacle19: '8_Octopus Tentacles/Tentacle19',
  _1_Welcome_and_Level_Screen_Spelly_Torso: '1_Welcome and Level Screen/Spelly_Torso',
  _3_Level_Assets_Common_Sub_Sm_RepeatBtn: '3_Level Assets_Common/Sub_Sm_RepeatBtn',
  _5_Level_2_Lvl2_KelpA_4: '5_Level 2/Lvl2_KelpA_4',
  _8_Octopus_Tentacles_Tentacle_Glow04: '8_Octopus Tentacles/Tentacle_Glow04',
  _4_Level_1_Lvl1_CoralRightBkgd: '4_Level 1/Lvl1_CoralRightBkgd',
  _7_Level_4_Lvl4_CoralRight: '7_Level 4/Lvl4_CoralRight',
  _8_Octopus_Tentacles_Tentacle_Glow07: '8_Octopus Tentacles/Tentacle_Glow07',
  _Jelly01_MG: 'Jelly01_MG',
  _1_Welcome_and_Level_Screen_GoBtn: '1_Welcome and Level Screen/GoBtn',
  _Jelly02_FG: 'Jelly02_FG',
  _Jelly01_FG: 'Jelly01_FG',
  _1_Welcome_and_Level_Screen_Spelly_WingHatch: '1_Welcome and Level Screen/Spelly_WingHatch',
  _HomeBtn: 'HomeBtn',
  _8_Octopus_Tentacles_Tentacle00: '8_Octopus Tentacles/Tentacle00',
  _Jelly05_MG: 'Jelly05_MG',
  _7_Level_4_Lvl4_Bkgd: '7_Level 4/Lvl4_Bkgd',
  _8_Octopus_Tentacles_Tentacle05: '8_Octopus Tentacles/Tentacle05',
  _8_Octopus_Tentacles_Tentacle_Glow00: '8_Octopus Tentacles/Tentacle_Glow00',
  _8_Octopus_Tentacles_Tentacle01: '8_Octopus Tentacles/Tentacle01',
  _8_Octopus_Tentacles_Tentacle_Glow01: '8_Octopus Tentacles/Tentacle_Glow01',
  _8_Octopus_Tentacles_Tentacle07: '8_Octopus Tentacles/Tentacle07',
  _8_Octopus_Tentacles_Tentacle_Glow08: '8_Octopus Tentacles/Tentacle_Glow08',
  _8_Octopus_Tentacles_Tentacle08: '8_Octopus Tentacles/Tentacle08',
  _8_Octopus_Tentacles_Tentacle09: '8_Octopus Tentacles/Tentacle09',
  _8_Octopus_Tentacles_Tentacle_Glow09: '8_Octopus Tentacles/Tentacle_Glow09',
  _8_Octopus_Tentacles_Tentacle10: '8_Octopus Tentacles/Tentacle10',
  _8_Octopus_Tentacles_Tentacle_Glow10: '8_Octopus Tentacles/Tentacle_Glow10',
  _8_Octopus_Tentacles_Tentacle11: '8_Octopus Tentacles/Tentacle11',
  _8_Octopus_Tentacles_Tentacle_Glow11: '8_Octopus Tentacles/Tentacle_Glow11',
  _8_Octopus_Tentacles_Tentacle15: '8_Octopus Tentacles/Tentacle15',
  _8_Octopus_Tentacles_Tentacle_Glow15: '8_Octopus Tentacles/Tentacle_Glow15',
  _8_Octopus_Tentacles_Tentacle13: '8_Octopus Tentacles/Tentacle13',
  _8_Octopus_Tentacles_Tentacle_Glow14: '8_Octopus Tentacles/Tentacle_Glow14',
  _8_Octopus_Tentacles_Tentacle16: '8_Octopus Tentacles/Tentacle16',
  _8_Octopus_Tentacles_Tentacle_Glow16: '8_Octopus Tentacles/Tentacle_Glow16',
  _8_Octopus_Tentacles_Tentacle_Glow17: '8_Octopus Tentacles/Tentacle_Glow17',
  _8_Octopus_Tentacles_Tentacle17: '8_Octopus Tentacles/Tentacle17',
  _8_Octopus_Tentacles_Tentacle_Glow19: '8_Octopus Tentacles/Tentacle_Glow19',
  _4_Level_1_Lvl1_CoralLeft: '4_Level 1/Lvl1_CoralLeft',
  _5_Level_2_Lvl2_KelpB_2: '5_Level 2/Lvl2_KelpB_2',
  _4_Level_1_Lvl1_Seaweed3: '4_Level 1/Lvl1_Seaweed3',
  _4_Level_1_Lvl1_Seaweed4: '4_Level 1/Lvl1_Seaweed4',
  _4_Level_1_Lvl1_Seaweed1: '4_Level 1/Lvl1_Seaweed1',
  _5_Level_2_Lvl2_KelpB_1: '5_Level 2/Lvl2_KelpB_1',
  _chestClosed: 'chestClosed',
  _SurfaceBtn: 'SurfaceBtn',
  _2_Transition_Screen_TranstionBbl: '2_Transition Screen/TranstionBbl',
  _4_Level_1_Lvl1_Seaweed2: '4_Level 1/Lvl1_Seaweed2',
  _7_Level_4_Lvl4_CoralLeft: '7_Level 4/Lvl4_CoralLeft',
  _chestOpen: 'chestOpen',
  _5_Level_2_Lvl2_KelpA_1: '5_Level 2/Lvl2_KelpA_1',
  _1_Welcome_and_Level_Screen_Sub_WindowFrgd_1: '1_Welcome and Level Screen/Sub_WindowFrgd_1',
  _4_Level_1_Lvl1_Anenomes: '4_Level 1/Lvl1_Anenomes',
  _3_Level_Assets_Common_LtrTile: '3_Level Assets_Common/LtrTile',
  _3_Level_Assets_Common_Sub_Sm_SkipBtn: '3_Level Assets_Common/Sub_Sm_SkipBtn',
  _8_Octopus_Tentacles_Tentacle12: '8_Octopus Tentacles/Tentacle12',
  _8_Octopus_Tentacles_Tentacle_Glow12: '8_Octopus Tentacles/Tentacle_Glow12',
  _8_Octopus_Tentacles_Tentacle_Glow13: '8_Octopus Tentacles/Tentacle_Glow13',
  _8_Octopus_Tentacles_Tentacle14: '8_Octopus Tentacles/Tentacle14',
  _8_Octopus_Tentacles_Tentacle18: '8_Octopus Tentacles/Tentacle18',
  _8_Octopus_Tentacles_Tentacle_Glow18: '8_Octopus Tentacles/Tentacle_Glow18',
}